export default __webpack_public_path__ + "static/media/patron-footer.53843ec8.svg";